import application from 'application/application';

application.value('googleAPI', {
	development: {
		clientID:
			'367139088348-e523fhpnck8cqed72duecf98numvcrv5.apps.googleusercontent.com',
		scopes:
			'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/tasks'
	},
	production: {
		clientID:
			'367139088348-e523fhpnck8cqed72duecf98numvcrv5.apps.googleusercontent.com',
		scopes:
			'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.events https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/tasks'
	}
});
